<!-- 文章列表 -->
<template>
    <div class="container">
        <div class="left-container">
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="md-add-circle"
                @click="goAddCategory"
                >新增分类</Button
            >
            <div class="card-container">
                <div
                    :class="category_value == index ? 'card-active' : 'card'"
                    v-for="(item, index) of category_list"
                    :key="item.id"
                    @click="activeCategory(index, item)"
                >
                    <div>{{ item.title }}</div>
                    <div class="category-right">
                        <img
                            src="@/assets/edit_name.png"
                            class="help-add-icon"
                            @click.stop="goAddCategory(item)"
                        />
                        <img
                            src="@/assets/delete.png"
                            class="help-del-icon"
                            @click.stop="goDelCategory(item)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="right-container">
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="md-add-circle"
                @click="goModal"
                >新增文章</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="status">
                    <i-switch
                        v-model="row.status"
                        size="large"
                        true-color="#FF761D "
                        :true-value="1"
                        :false-value="0"
                        @on-change="changeStatus(row)"
                    >
                    </i-switch>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost @click="goModal(row)"
                            >编辑</Button
                        >
                        <Button type="error" ghost @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="600"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="文章标题:">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.title"
                            placeholder="请输入文章标题"
                        ></Input>
                    </FormItem>
                    <FormItem label="序号:">
                        <Input
                            class="w300"
                            type="number"
                            v-model="formData.sort"
                            placeholder="请输入序号"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D "
                            />
                            <div slot="content">
                                <p>倒序，序号越大，越在前面</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="创建时间:">
                        <DatePicker
                            class="w200"
                            :value="formData.created_at"
                            type="datetime"
                            placeholder="请选择"
                            @on-change="changeTime"
                        ></DatePicker>
                    </FormItem>
                    <FormItem label="是否发布:">
                        <i-switch
                            v-model="formData.status"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                        >
                        </i-switch>
                    </FormItem>
                    <FormItem label="封面图片:">
                        <div class="form-upload" @click="openModal(1)">
                            <img
                                class="wh100"
                                v-if="show_img"
                                :src="show_img"
                            />
                            <Icon
                                v-else
                                type="ios-add"
                                size="44"
                                color="#AEAEB3"
                            />
                        </div>
                    </FormItem>
                    <FormItem label="文章内容:">
                        <editor
                            class="editor-div"
                            :edtor-con="formData.content"
                            :index="1"
                            @getContent="getEnContent"
                        />
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 新增/编辑 -->
        <Modal
            v-model="add_category_modal"
            :title="add_category_modal_title"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="form_category_item"
                label-position="right"
                :label-width="100"
            >
                <FormItem label="分类名称：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_category_item.title"
                        placeholder="请输入分类名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelCategoryModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="submitCategoryModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    article_list,
    article_save,
    article_status,
    article_delete,
    article_sort,
    article_info,
    article_type_save,
    article_type_delete,
    article_type,
} from "@/api/index";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { pictureLibrary, editor },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 30,
                type_id: "",
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "排序", key: "sort", align: "center", width: "100px" },
                { title: "文章标题", key: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            formData: {
                id: "",
                title: "",
                content: "",
                sort: "",
                status: 0,
                img: "",
                created_at: "",
                type_id: "",
            },
            show_img: "",
            modals: false,
            modalTitle: "",
            category_list: [],
            category_value: 0,
            add_category_modal: false,
            add_category_modal_title: "",
            form_category_item: {
                title: "",
                id: "",
            },
        };
    },
    mounted() {
        this.getArticleType();
    },
    methods: {
        getArticleType() {
            return article_type()
                .then((res) => {
                    this.category_list = res.data || [];
                    if (this.category_list.length > 0) {
                        this.storePrams.type_id = this.category_list[0].id;
                        this.formData.type_id = this.category_list[0].id;
                    }
                    this.getList();
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                if (param1.length) this.show_img = param1[param1.length - 1];
                if (param2.length)
                    this.formData.img = param2[param2.length - 1];
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            article_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 确定
        submitModal() {
            const data = {
                id: this.formData.id,
                title: this.formData.title,
                content: this.formData.content,
                sort: this.formData.sort,
                status: this.formData.status,
                img: this.formData.img,
                type_id: this.formData.type_id,
            };
            if (this.formData.created_at) {
                data.created_at = this.formData.created_at;
            }
            article_save(data)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goModal(row) {
            if (row && row.id) {
                this.modalTitle = "编辑文章";
                this.formData.id = row.id;
                this.getInfo().then(() => {
                    this.modals = true;
                });
            } else {
                this.modalTitle = "新增文章";
                this.resetForm();
                const now = new Date();
                this.formData.created_at = this.formatDateTime(now);
                this.getSort();
                this.$nextTick(() => {
                    this.modals = true;
                });
            }
        },
        resetForm() {
            this.formData.id = "";
            this.formData.title = "";
            this.formData.content = "";
            this.formData.sort = "";
            this.formData.status = 0;
            this.formData.img = "";
            this.show_img = "";
        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            const seconds = date.getSeconds().toString().padStart(2, "0");
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        getInfo() {
            return article_info({ id: this.formData.id })
                .then((res) => {
                    this.formData.title = res.data.title;
                    this.formData.content = res.data.content;
                    this.formData.sort = res.data.sort;
                    this.formData.status = res.data.status;
                    this.formData.img = res.data.img;
                    this.formData.created_at = res.data.created_at;
                    this.show_img = res.data.show_img;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                    return Promise.reject(err);
                });
        },
        getSort() {
            article_sort()
                .then((res) => {
                    this.formData.sort = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    article_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        changeStatus(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "是否修改状态？",
                onOk: () => {
                    article_status({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.getList();
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        changeTime(e) {
            if (e) {
                this.formData.created_at = e;
            } else {
                this.formData.created_at = "";
            }
        },
        //富文本
        getEnContent(detailData) {
            this.formData.content = detailData.editorData;
        },
        goAddCategory(item) {
            if (item && item.id) {
                this.add_category_modal_title = "编辑分类";
                this.form_category_item.title = item.title;
                this.form_category_item.id = item.id;
            } else {
                this.add_category_modal_title = "新增分类";
                this.form_category_item.title = "";
                this.form_category_item.id = "";
            }
            this.$nextTick(() => {
                this.add_category_modal = true;
            });
        },
        // 确定
        submitCategoryModal() {
            const currentTypeId = this.storePrams.type_id;
            article_type_save(this.form_category_item)
                .then((res) => {
                    this.add_category_modal = false;
                    this.$Message.success(res.msg);
                    this.getArticleType().then(() => {
                        const idx = this.category_list.findIndex(
                            (c) => c.id === currentTypeId
                        );
                        if (idx >= 0) {
                            this.category_value = idx;
                            this.storePrams.type_id = currentTypeId;
                            this.formData.type_id = currentTypeId;
                            this.getList();
                        }
                    });
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelCategoryModal() {
            this.add_category_modal = false;
        },
        activeCategory(index, item) {
            this.category_value = index;
            if (item) {
                this.storePrams.type_id = item.id;
                this.formData.type_id = item.id;
            }
            this.getList();
        },
        goDelCategory(item) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    article_type_delete({ id: item.id })
                        .then((res) => {
                            this.getArticleType();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
}
.left-container {
    padding: 24px 12px;
    width: 333px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-right: 1px solid #eee;
}
.right-container {
    padding: 24px;
    width: calc(100% - 333px);
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.form-upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.cursor-p {
    cursor: pointer;
}
.editor-div {
    width: 100%;
}
.card-container {
    width: 100%;
}
.card-active {
    padding: 10px;
    background: #e8eaf4;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
}
.card {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
}
.category-right {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.help-add-icon {
    margin-left: 24px;
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
}
.help-del-icon {
    margin: 0 2px 0 12px;
    min-width: 20px;
    width: 20px;
    min-height: 20px;
    height: 20px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>